export const CONSTANTS_BY_TYPES_INIT = '[CONSTANTS_BY_TYPE] CONSTANTS_BY_TYPES_INIT';
export const CONSTANTS_BY_TYPES_SUCCESS = '[CONSTANTS_BY_TYPE] CONSTANTS_BY_TYPES_SUCCESS';
export const CONSTANTS_BY_TYPES_ERROR = '[CONSTANTS_BY_TYPE] CONSTANTS_BY_TYPES_ERROR';
export const CONSTANTS_LIST_INIT = '[CONSTANTS] CONSTANTS_LIST_INIT';
export const CONSTANTS_LIST_SUCCESS = '[CONSTANTS] CONSTANTS_LIST_SUCCESS';
export const CONSTANTS_LIST_ERROR = '[CONSTANTS] CONSTANTS_LIST_ERROR';
